import { z } from "zod";

const isServer = typeof window === "undefined";

const clientEnvSchema = z.object({
  DEV: z.boolean(),
  VITE_API_URL: z.string(),
  VITE_LOCAL_API_URL: z.string(),
});

let clientEnvSingleton: z.infer<typeof clientEnvSchema> | undefined;

function getClientEnv() {
  if (clientEnvSingleton) {
    return clientEnvSingleton;
  }

  const parsedClient = clientEnvSchema.safeParse(import.meta.env);

  if (!parsedClient.success) {
    console.error(
      "❌ Invalid client environment variables:",
      parsedClient.error.format(),
    );
    throw new Error("Invalid client environment variables");
  }

  clientEnvSingleton = parsedClient.data;
  return clientEnvSingleton;
}

const serverEnvSchema = z.object({
  NODE_ENV: z.enum(["development", "production"]),
});

let serverEnvSingleton: z.infer<typeof serverEnvSchema> | undefined;

function getServerEnv() {
  if (isServer) {
    if (serverEnvSingleton) {
      return serverEnvSingleton;
    }

    const parsedServer = serverEnvSchema.safeParse(process.env);

    if (!parsedServer.success) {
      console.error(
        "❌ Invalid server environment variables:",
        parsedServer.error.format(),
      );
      throw new Error("Invalid server environment variables");
    }

    serverEnvSingleton = parsedServer.data;
    return parsedServer.data;
  }
  return null;
}

export const env = {
  ...getClientEnv(),
  ...(getServerEnv() as z.infer<typeof serverEnvSchema>),
};
